import React, { useState } from 'react';
import useUserAuth from './useUserAuth';
import { loginMachine } from './auth/loginMachine';
import {
  USER_GEMINI_API_KEY_STORAGE_KEY,
  extractGeminiApiKey,
} from './packages/audio-narration-core';

// Export LANGUAGE_OPTIONS so it can be used in other components
export const LANGUAGE_OPTIONS = [
  { code: 'de-DE', label: 'Deutsch', flag: 'https://flagcdn.com/28x21/de.png', wikiLangCode: 'de' },
  { code: 'en-AU', label: 'English', flag: 'https://flagcdn.com/28x21/au.png', wikiLangCode: 'en' },
  { code: 'en-GB', label: 'English', flag: 'https://flagcdn.com/28x21/gb.png', wikiLangCode: 'en' },
  { code: 'en-IN', label: 'English', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'en' },
  { code: 'en-US', label: 'English', flag: 'https://flagcdn.com/28x21/us.png', wikiLangCode: 'en' },
  { code: 'es-US', label: 'Spanish', flag: 'https://flagcdn.com/28x21/us.png', wikiLangCode: 'es' },
  { code: 'fr-FR', label: 'Français', flag: 'https://flagcdn.com/28x21/fr.png', wikiLangCode: 'fr' },
  { code: 'hi-IN', label: 'हिंदी', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'hi' },
  { code: 'pt-BR', label: 'Português', flag: 'https://flagcdn.com/28x21/br.png', wikiLangCode: 'pt' },
  { code: 'ar-XA', label: 'العربية', flag: 'https://flagcdn.com/28x21/sa.png', wikiLangCode: 'ar' },
  { code: 'es-ES', label: 'Español', flag: 'https://flagcdn.com/28x21/es.png', wikiLangCode: 'es' },
  { code: 'fr-CA', label: 'Français', flag: 'https://flagcdn.com/28x21/ca.png', wikiLangCode: 'fr' },
  { code: 'id-ID', label: 'Bahasa Indonesia', flag: 'https://flagcdn.com/28x21/id.png', wikiLangCode: 'id' },
  { code: 'it-IT', label: 'Italiano', flag: 'https://flagcdn.com/28x21/it.png', wikiLangCode: 'it' },
  { code: 'ja-JP', label: '日本語', flag: 'https://flagcdn.com/28x21/jp.png', wikiLangCode: 'ja' },
  { code: 'tr-TR', label: 'Türkçe', flag: 'https://flagcdn.com/28x21/tr.png', wikiLangCode: 'tr' },
  { code: 'vi-VN', label: 'Tiếng Việt', flag: 'https://flagcdn.com/28x21/vn.png', wikiLangCode: 'vi' },
  { code: 'bn-IN', label: 'বাংলা', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'bn' },
  { code: 'gu-IN', label: 'ગુજરાતી', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'gu' },
  { code: 'kn-IN', label: 'ಕನ್ನಡ', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'kn' },
  { code: 'ml-IN', label: 'മലയാളം', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'ml' },
  { code: 'mr-IN', label: 'मराठी', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'mr' },
  { code: 'ta-IN', label: 'தமிழ்', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'ta' },
  { code: 'te-IN', label: 'తెలుగు', flag: 'https://flagcdn.com/28x21/in.png', wikiLangCode: 'te' },
  { code: 'nl-NL', label: 'Nederlands', flag: 'https://flagcdn.com/28x21/nl.png', wikiLangCode: 'nl' },
  { code: 'ko-KR', label: '한국어', flag: 'https://flagcdn.com/28x21/kr.png', wikiLangCode: 'ko' },
  { code: 'cmn-CN', label: '中文', flag: 'https://flagcdn.com/28x21/cn.png', wikiLangCode: 'zh' },
  { code: 'pl-PL', label: 'Polski', flag: 'https://flagcdn.com/28x21/pl.png', wikiLangCode: 'pl' },
  { code: 'ru-RU', label: 'Русский', flag: 'https://flagcdn.com/28x21/ru.png', wikiLangCode: 'ru' },
  { code: 'th-TH', label: 'ไทย', flag: 'https://flagcdn.com/28x21/th.png', wikiLangCode: 'th' },
];

const GoogleIcon = ({ style = {} }) => (
  <svg viewBox="0 0 48 48" aria-hidden="true" style={{ width: 18, height: 18, ...style }}>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.22c-.5-1.52-.76-3.13-.76-4.72s.26-3.2.76-4.72l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.56z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

const getEmailAuthErrorMessage = (err) => {
  switch (err?.code) {
    case 'auth/invalid-email':
      return 'Invalid email address. Please check and try again.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please try again later.';
    case 'auth/quota-exceeded':
      return 'Email quota exceeded. Please try again later.';
    default:
      return err?.message || 'Could not send the sign-in link. Please try again.';
  }
};

function readSavedUserGeminiApiKey() {
  try {
    return extractGeminiApiKey(localStorage.getItem(USER_GEMINI_API_KEY_STORAGE_KEY) || '');
  } catch (_) {
    return '';
  }
}

function maskGeminiApiKey(apiKey) {
  const trimmed = String(apiKey || '').trim();
  if (!trimmed) return '';
  const visibleSuffix = trimmed.length > 6 ? trimmed.slice(-4) : '';
  return `${'•'.repeat(18)}${visibleSuffix ? ` ${visibleSuffix}` : ''}`;
}

const MainMenu = ({
  isOpen,
  onClose,
  userLanguage,
  onLanguageChange,
  showGuestPrompt = true,
  showPwaInstallButton = false,
  onPwaInstallClick,
}) => {
  const { isSignedIn, displayName, email, logout, isLoading } = useUserAuth();
  const [emailMode, setEmailMode] = useState('providers');
  const [emailAddress, setEmailAddress] = useState('');
  const [authError, setAuthError] = useState('');
  const [authBusy, setAuthBusy] = useState(null);
  const [geminiApiKey, setGeminiApiKey] = useState(readSavedUserGeminiApiKey);
  const [apiKeyDraft, setApiKeyDraft] = useState('');
  const [apiKeyStatus, setApiKeyStatus] = useState('');
  const [isEditingApiKey, setIsEditingApiKey] = useState(false);
  const [showApiKeyPopup, setShowApiKeyPopup] = useState(false);
  const showDebugSignInTrigger =
    process.env.NODE_ENV !== 'production' ||
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  if (!isOpen) return null;

  const handleLogout = async () => {
    try {
      await logout();
      onClose(); // Close menu after logout
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleGoogleSignIn = async () => {
    setAuthError('');
    setAuthBusy('google');

    try {
      await loginMachine.continueWithGooglePopup('manual', {
        fallbackToPrompt: false,
        showGlobalBusy: false,
      });
      onClose();
    } catch (error) {
      setAuthError(error?.message || 'Google sign-in failed. Please try again.');
    } finally {
      setAuthBusy(null);
    }
  };

  const handleSendEmailLink = async () => {
    setAuthError('');
    setAuthBusy('email');

    try {
      await loginMachine.sendEmailSignInLink(emailAddress);
      setEmailMode('email-sent');
    } catch (error) {
      setAuthError(getEmailAuthErrorMessage(error));
    } finally {
      setAuthBusy(null);
    }
  };

  const handleDebugSignInModal = () => {
    onClose();
    window.setTimeout(() => {
      loginMachine.requestLogin('manual', { preferQuickPrompt: false });
    }, 0);
  };

  const handleInstallClick = () => {
    onClose();
    window.setTimeout(() => {
      onPwaInstallClick?.();
    }, 0);
  };

  const saveUserGeminiApiKey = (rawKey = apiKeyDraft) => {
    const nextKey = extractGeminiApiKey(rawKey);
    try {
      if (nextKey) {
        localStorage.setItem(USER_GEMINI_API_KEY_STORAGE_KEY, nextKey);
        setGeminiApiKey(nextKey);
        setApiKeyDraft('');
        setIsEditingApiKey(false);
        setApiKeyStatus('Saved locally.');
      } else {
        localStorage.removeItem(USER_GEMINI_API_KEY_STORAGE_KEY);
        setGeminiApiKey('');
        setApiKeyDraft('');
        setIsEditingApiKey(true);
        setApiKeyStatus('Removed.');
      }
      window.dispatchEvent(new CustomEvent('userGeminiApiKeyChanged', {
        detail: { hasKey: !!nextKey },
      }));
    } catch (error) {
      console.error('Failed to save Gemini API key:', error);
      setApiKeyStatus('Could not save the key in this browser.');
    }
  };

  const handleApiKeyPaste = (event) => {
    const pasted = event.clipboardData?.getData('text') || '';
    const nextKey = extractGeminiApiKey(pasted);
    if (!nextKey) return;

    event.preventDefault();
    setApiKeyDraft(nextKey);
    setApiKeyStatus('');
  };

  // Get display name or fallback to email or "User"
  const getUserDisplayName = () => {
    if (displayName) return displayName;
    if (email) return email.split('@')[0]; // Use part before @ as display name
    return 'User';
  };

  return (
    <div
      style={{ // Full-screen Overlay for main menu
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        background: 'rgba(0, 0, 0, 0.7)', // Darker overlay
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start', // Align to top
        paddingTop: '20px', // Add padding to avoid sticking to the very top edge
        zIndex: 5500
      }}
      onClick={onClose}
    >
      <div
        style={{ // Menu Card
          background: '#333333',
          border: '1px solid #555555',
          borderRadius: '12px',
          padding: '16px',
          width: 'clamp(300px, 80vw, 500px)',
          maxHeight: '70vh', // Increased to accommodate account section
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 6px 25px rgba(0,0,0,0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{ // Sticky header
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'sticky',
            top: 0,
            background: '#333333',
            zIndex: 1,
            paddingBottom: '10px',
          }}
        >
          <h2 style={{ margin: 0, color: '#f0f0f0', fontWeight: '600', fontSize: '16px' }}>
            Menu
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: '#dddddd',
              fontSize: '28px',
              cursor: 'pointer'
            }}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>

        <div style={{ overflowY: 'auto', flex: 1 }}>
          {/* Account Section */}
          {!isLoading && (
            <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #555555' }}>
              <h3 style={{ margin: '0 0 12px 0', color: '#f0f0f0', fontWeight: '600', fontSize: '14px' }}>
                Account
              </h3>
              {isSignedIn ? (
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      background: '#444444',
                      border: '1px solid #555555',
                      marginBottom: '8px',
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <div style={{ color: '#f0f0f0', fontWeight: '500', fontSize: '14px' }}>
                        {getUserDisplayName()}
                      </div>
                      {email && email !== getUserDisplayName() && (
                        <div style={{ color: '#cccccc', fontSize: '12px', marginTop: '2px' }}>
                          {email}
                        </div>
                      )}
                    </div>
                    <button
                      onClick={handleLogout}
                      style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        background: 'transparent',
                        border: '1px solid #666666',
                        color: '#cccccc',
                        fontSize: '12px',
                        fontWeight: '400',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        marginLeft: '8px',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#555555';
                        e.currentTarget.style.borderColor = '#777777';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.borderColor = '#666666';
                      }}
                    >
                      Sign Out
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  {showGuestPrompt && (
                    <div
                      style={{
                        color: 'limegreen',
                        fontSize: '16px',
                        fontWeight: '600',
                        textAlign: 'center',
                        marginBottom: '12px'
                      }}
                    >
                      Sign in to use all features
                    </div>
                  )}
                  {authError && (
                    <div
                      style={{
                        padding: '8px 10px',
                        borderRadius: '8px',
                        border: '1px solid rgba(220, 53, 69, 0.55)',
                        background: 'rgba(220, 53, 69, 0.16)',
                        color: '#ffd9de',
                        fontSize: '12px',
                        marginBottom: '10px',
                      }}
                    >
                      {authError}
                    </div>
                  )}

                  {emailMode === 'providers' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <button
                        onClick={handleGoogleSignIn}
                        disabled={!!authBusy}
                        style={{
                          width: '100%',
                          minHeight: '40px',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          background: '#ffffff',
                          border: '1px solid #d1d5db',
                          color: '#111827',
                          fontSize: '14px',
                          fontWeight: '700',
                          cursor: authBusy ? 'wait' : 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '10px',
                          opacity: authBusy ? 0.72 : 1,
                        }}
                      >
                        <GoogleIcon />
                        {authBusy === 'google' ? 'Signing in...' : 'Sign in with Google'}
                      </button>

                      <button
                        onClick={() => {
                          setAuthError('');
                          setEmailMode('email');
                        }}
                        disabled={!!authBusy}
                        style={{
                          width: '100%',
                          minHeight: '40px',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          background: '#444444',
                          border: '1px solid #666666',
                          color: '#f0f0f0',
                          fontSize: '14px',
                          fontWeight: '700',
                          cursor: authBusy ? 'wait' : 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '10px',
                          opacity: authBusy ? 0.72 : 1,
                        }}
                      >
                        <i className="fas fa-envelope" aria-hidden="true" />
                        Sign in with Email
                      </button>
                    </div>
                  )}

                  {emailMode === 'email' && (
                    <div>
                      <button
                        onClick={() => {
                          setAuthError('');
                          setEmailMode('providers');
                        }}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          color: '#cccccc',
                          fontSize: '12px',
                          padding: '0 0 8px',
                          cursor: 'pointer',
                        }}
                      >
                        ← Back
                      </button>
                      <input
                        type="email"
                        value={emailAddress}
                        onChange={(event) => setEmailAddress(event.target.value)}
                        placeholder="Email address"
                        autoComplete="email"
                        style={{
                          width: '100%',
                          boxSizing: 'border-box',
                          padding: '10px 12px',
                          borderRadius: '8px',
                          border: '1px solid #666666',
                          background: '#2b2b2b',
                          color: '#f0f0f0',
                          marginBottom: '8px',
                          fontSize: '14px',
                        }}
                      />
                      <button
                        onClick={handleSendEmailLink}
                        disabled={authBusy === 'email' || !emailAddress}
                        style={{
                          width: '100%',
                          minHeight: '40px',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          background: '#007bff',
                          border: '1px solid #0056b3',
                          color: '#ffffff',
                          fontSize: '14px',
                          fontWeight: '700',
                          cursor: authBusy === 'email' ? 'wait' : 'pointer',
                          opacity: authBusy === 'email' || !emailAddress ? 0.72 : 1,
                        }}
                      >
                        {authBusy === 'email' ? 'Sending...' : 'Send Sign-in Link'}
                      </button>
                    </div>
                  )}

                  {emailMode === 'email-sent' && (
                    <div>
                      <div style={{ color: '#dddddd', fontSize: '13px', lineHeight: 1.4, marginBottom: '10px' }}>
                        Check {emailAddress || 'your email'} for a sign-in link. Also check your spam folder.
                      </div>
                      <button
                        onClick={handleSendEmailLink}
                        disabled={authBusy === 'email'}
                        style={{
                          width: '100%',
                          minHeight: '38px',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          background: 'transparent',
                          border: '1px solid #666666',
                          color: '#f0f0f0',
                          fontSize: '14px',
                          fontWeight: '600',
                          cursor: authBusy === 'email' ? 'wait' : 'pointer',
                          opacity: authBusy === 'email' ? 0.72 : 1,
                        }}
                      >
                        {authBusy === 'email' ? 'Sending...' : 'Resend Email'}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
	          )}

	          <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #555555' }}>
	            <h3 style={{ margin: '0 0 12px 0', color: '#f0f0f0', fontWeight: '600', fontSize: '14px' }}>
	              Get audio guides for free
	            </h3>
	            {geminiApiKey ? (
	              <div>
	                <div
	                  aria-label="Saved Gemini API key"
	                  style={{
	                    width: '100%',
	                    boxSizing: 'border-box',
	                    padding: '10px 12px',
	                    borderRadius: '8px',
	                    border: '1px solid #666666',
	                    background: '#2b2b2b',
	                    color: '#f0f0f0',
	                    marginBottom: '8px',
	                    fontSize: '14px',
	                    letterSpacing: '0',
	                    fontFamily: 'monospace',
	                  }}
	                >
	                  {maskGeminiApiKey(geminiApiKey)}
	                </div>
	                <div style={{ display: 'flex', gap: '8px' }}>
	                  <button
	                    type="button"
		                    onClick={() => {
		                      setApiKeyStatus('');
		                      setApiKeyDraft('');
		                      setIsEditingApiKey(true);
		                      setShowApiKeyPopup(true);
		                    }}
	                    style={{
	                      flex: 1,
	                      minHeight: '38px',
	                      padding: '8px 12px',
	                      borderRadius: '8px',
	                      background: '#007bff',
	                      border: '1px solid #0056b3',
	                      color: '#ffffff',
	                      fontSize: '14px',
	                      fontWeight: '700',
	                      cursor: 'pointer',
	                    }}
	                  >
	                    Change Key
	                  </button>
	                  <button
	                    type="button"
	                    onClick={() => saveUserGeminiApiKey('')}
	                    style={{
	                      minHeight: '38px',
	                      padding: '8px 12px',
	                      borderRadius: '8px',
	                      background: 'transparent',
	                      border: '1px solid #666666',
	                      color: '#f0f0f0',
	                      fontSize: '14px',
	                      fontWeight: '600',
	                      cursor: 'pointer',
	                    }}
	                  >
	                    Clear
	                  </button>
	                </div>
	              </div>
	            ) : (
	              <button
	                type="button"
		                onClick={() => {
		                  setApiKeyStatus('');
		                  setIsEditingApiKey(true);
		                  setShowApiKeyPopup(true);
		                }}
	                style={{
	                  width: '100%',
	                  minHeight: '40px',
	                  padding: '9px 12px',
	                  borderRadius: '8px',
	                  background: '#007bff',
	                  border: '1px solid #0056b3',
	                  color: '#ffffff',
	                  fontSize: '14px',
	                  fontWeight: '700',
	                  cursor: 'pointer',
	                }}
	              >
	                Get free Gemini API Key
	              </button>
	            )}
            {(apiKeyStatus || geminiApiKey) && (
              <div style={{ color: '#cccccc', fontSize: '12px', lineHeight: 1.4, marginTop: '8px' }}>
                {apiKeyStatus || 'Saved locally.'}
              </div>
            )}
	          </div>

	          {showDebugSignInTrigger && (
	            <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #555555' }}>
	              <h3 style={{ margin: '0 0 12px 0', color: '#f0f0f0', fontWeight: '600', fontSize: '14px' }}>
	                Debug
              </h3>
              <button
                onClick={handleDebugSignInModal}
                style={{
                  width: '100%',
                  minHeight: '38px',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  background: '#3b2f1d',
                  border: '1px solid #8a6d3b',
                  color: '#ffe8b5',
                  fontSize: '13px',
                  fontWeight: '700',
                  cursor: 'pointer',
                }}
              >
                Show sign-in modal
              </button>
            </div>
          )}

          {showPwaInstallButton && (
            <div style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #555555' }}>
              <h3 style={{ margin: '0 0 12px 0', color: '#f0f0f0', fontWeight: '600', fontSize: '14px' }}>
                App
              </h3>
              <button
                onClick={handleInstallClick}
                style={{
                  width: '100%',
                  minHeight: '40px',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  background: '#444444',
                  border: '1px solid #666666',
                  color: '#f0f0f0',
                  fontSize: '14px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
              >
                <i className="fas fa-download" aria-hidden="true" />
                Install app
              </button>
            </div>
          )}

	          {/* Language Section */}
          <div>
            <h3 style={{ margin: '0 0 12px 0', color: '#f0f0f0', fontWeight: '600', fontSize: '14px' }}>
              Language
            </h3>
            {LANGUAGE_OPTIONS.map((lang) => (
              <div
                key={lang.code}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  padding: '8px 12px',
                  borderRadius: '8px',
                  marginBottom: '8px',
                  background: userLanguage === lang.code ? '#007bff' : '#444444',
                  border: userLanguage === lang.code ? '1px solid #0056b3' : '1px solid #555555',
                  transition: 'background-color 0.2s ease, border-color 0.2s ease',
                }}
                onClick={() => {
                  onLanguageChange(lang.code);
                  onClose();
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = userLanguage === lang.code ? '#0069d9' : '#555555'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = userLanguage === lang.code ? '#007bff' : '#444444'}
              >
                <img
                  src={lang.flag}
                  alt={lang.label + ' flag'}
                  style={{ marginRight: '12px', width: '24px', height: '18px', borderRadius: '4px' }}
                  onError={(e) => { e.target.src = 'https://via.placeholder.com/28x21'; e.target.alt = lang.code; }}
                />
                <span style={{
                  color: userLanguage === lang.code ? '#ffffff' : '#dddddd',
                  fontWeight: userLanguage === lang.code ? 'bold' : '500',
                  fontSize: '14px'
                }}>
                  {lang.label}
                </span>
                {userLanguage === lang.code && (
                  <span style={{ marginLeft: 'auto', color: '#ffffff', fontWeight: 'bold' }}>
                    ✓
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
        {showApiKeyPopup && (
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Gemini API key setup"
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(0, 0, 0, 0.72)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '18px',
              zIndex: 5600,
            }}
            onClick={(event) => {
              event.stopPropagation();
              setShowApiKeyPopup(false);
              setIsEditingApiKey(false);
            }}
          >
            <div
              style={{
                width: 'min(92vw, 460px)',
                maxHeight: '86vh',
                overflowY: 'auto',
                background: '#333333',
                border: '1px solid #666666',
                borderRadius: '12px',
                boxShadow: '0 10px 35px rgba(0,0,0,0.38)',
                padding: '16px',
              }}
              onClick={(event) => event.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                <button
                  type="button"
                  aria-label="Close API key setup"
                  onClick={() => {
                    setShowApiKeyPopup(false);
                    setIsEditingApiKey(false);
                  }}
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '8px',
                    border: '1px solid #666666',
                    background: '#444444',
                    color: '#f0f0f0',
                    fontSize: '20px',
                    lineHeight: 1,
                    cursor: 'pointer',
                  }}
                >
                  ×
                </button>
              </div>

              <div style={{ display: 'grid', gap: 0 }}>
                <section style={{ display: 'grid', gap: '8px', marginBottom: '24px' }}>
                  <div style={{ color: '#f0f0f0', fontSize: '14px', fontWeight: 800 }}>
                    1. Get free Gemini API key
                  </div>
                  <div style={{ color: '#cccccc', fontSize: '13px', lineHeight: 1.4 }}>
                    With a free Gemini API key from Google AI Studio, you can get almost unlimited free audio guides.
                  </div>
                  <video
                    aria-label="Gemini API key tutorial video"
                    autoPlay
                    controls
                    loop
                    muted
                    playsInline
                    preload="none"
                    style={{
                      width: '100%',
                      aspectRatio: '16 / 9',
                      borderRadius: '8px',
                      border: '1px solid #666666',
                      background: '#252525',
                      display: 'block',
                    }}
                  >
                    <source src={`${process.env.PUBLIC_URL}/videos/gemini-curio-api-key-tutorial.mp4`} type="video/mp4" />
                  </video>
                  <a
                    href="https://aistudio.google.com/api-keys"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      minHeight: '38px',
                      padding: '8px 12px',
                      borderRadius: '8px',
                      background: '#f0f0f0',
                      border: '1px solid #ffffff',
                      color: '#222222',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: 800,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    Open Google AI Studio
                  </a>
                </section>

                <section style={{ display: 'grid', gap: '8px' }}>
                  <div style={{ color: '#f0f0f0', fontSize: '14px', fontWeight: 800 }}>
                    2. Paste key here.
                  </div>
                  {geminiApiKey && !isEditingApiKey ? (
                    <div
                      aria-label="Saved Gemini API key"
                      style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '10px 12px',
                        borderRadius: '8px',
                        border: '1px solid #666666',
                        background: '#2b2b2b',
                        color: '#f0f0f0',
                        fontSize: '14px',
                        fontFamily: 'monospace',
                        letterSpacing: '0',
                      }}
                    >
                      {maskGeminiApiKey(geminiApiKey)}
                    </div>
                  ) : (
                    <>
                      <input
                        type="text"
                        value={apiKeyDraft}
                        onChange={(event) => {
                          setApiKeyDraft(event.target.value);
                          setApiKeyStatus('');
                        }}
                        onPaste={handleApiKeyPaste}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                            saveUserGeminiApiKey(apiKeyDraft);
                            setShowApiKeyPopup(false);
                          }
                        }}
                        placeholder="Paste key here"
                        name="curio-local-token-value"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="none"
                        spellCheck={false}
                        data-lpignore="true"
                        data-1p-ignore="true"
                        style={{
                          width: '100%',
                          boxSizing: 'border-box',
                          padding: '10px 12px',
                          borderRadius: '8px',
                          border: '1px solid #666666',
                          background: '#2b2b2b',
                          color: '#f0f0f0',
                          fontSize: '14px',
                        }}
                      />
                      <button
                        type="button"
                        disabled={!apiKeyDraft.trim()}
                        onClick={() => {
                          saveUserGeminiApiKey(apiKeyDraft);
                          setShowApiKeyPopup(false);
                        }}
                        style={{
                          width: '100%',
                          minHeight: '38px',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          background: '#007bff',
                          border: '1px solid #0056b3',
                          color: '#ffffff',
                          fontSize: '14px',
                          fontWeight: '700',
                          cursor: apiKeyDraft.trim() ? 'pointer' : 'default',
                          opacity: apiKeyDraft.trim() ? 1 : 0.55,
                        }}
                      >
                        Done
                      </button>
                    </>
                  )}
                </section>

              </div>

              {(apiKeyStatus || geminiApiKey) && (
                <div style={{ color: '#cccccc', fontSize: '12px', lineHeight: 1.4, marginTop: '12px' }}>
                  {apiKeyStatus || 'Saved locally.'}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainMenu;
